// extracted by mini-css-extract-plugin
module.exports = {"hoverIcon":"FooterSocials_hoverIcon__Tkkpf"};